module.exports = __webpack_public_path__ + "static/media/2023-og-image-klo.7c034673.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/2023-og-image-klo.jpg
// module id = 1530
// module chunks = 1